"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styled = require("../base/styled");
var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _capitalize = _interopRequireDefault(require("lodash/capitalize"));
var _lowerCase = _interopRequireDefault(require("lodash/lowerCase"));
var _compact = _interopRequireDefault(require("lodash/compact"));
var _isNull = _interopRequireDefault(require("lodash/isNull"));
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var FiltersList = function FiltersList(_ref) {
  var onRemove = _ref.onRemove,
    filters = _ref.filters,
    $bsStyle = _ref.$bsStyle;
  var selectedFilters = Object.entries(filters);
  var hasFilters = !(0, _isEmpty.default)((0, _compact.default)(selectedFilters.map(function (filter) {
    return !(0, _isNull.default)(filter[1]);
  })));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasFilters && /*#__PURE__*/_react.default.createElement(_styled.Row, {
    $bsStyle: $bsStyle
  }, selectedFilters.map(function (filter) {
    return ((0, _isBoolean.default)(filter[1]) || (0, _isString.default)(filter[1]) || (0, _isNumber.default)(filter[1]) ? filter[1] : !(0, _isEmpty.default)(filter[1])) && /*#__PURE__*/_react.default.createElement(_styled2.Item, {
      key: filter[0]
    }, /*#__PURE__*/_react.default.createElement(_styled2.RemoveButton, {
      id: filter[0],
      role: "button",
      onClick: onRemove
    }, "x"), /*#__PURE__*/_react.default.createElement(_styled2.ItemLabel, null, (0, _capitalize.default)((0, _lowerCase.default)(filter[0]))));
  })));
};
FiltersList.propTypes = {
  onRemove: _propTypes.default.func.isRequired,
  $bsStyle: _propTypes.default.shape({}),
  filters: _propTypes.default.shape({})
};
FiltersList.defaultProps = {
  $bsStyle: undefined,
  filters: {}
};
var _default = FiltersList;
exports.default = _default;